export type LeadStageConfig = {
  slug: string;
  name: string;
  auto_disable_agent: boolean;
  /** Quando true, estágio usa visual urgente (laranja) — independente de auto_disable_agent. */
  is_human_handoff?: boolean;
  funnel_id?: string | null;
};

export function buildStageHandoffMap(stages: LeadStageConfig[]): Map<string, LeadStageConfig> {
  return new Map(stages.map((s) => [s.slug, s]));
}

/** Verifica se estágio pausa IA — usa flag; fallback legado para slug conhecido. */
export function isAgentHandoffStage(
  stageSlug: string | null | undefined,
  stagesBySlug?: Map<string, LeadStageConfig>,
): boolean {
  if (!stageSlug) return false;
  const cfg = stagesBySlug?.get(stageSlug);
  if (cfg) return cfg.auto_disable_agent === true;
  return stageSlug === "atendimento_humano";
}

/** Visual urgente/laranja — só atendimento humano explícito, não todo auto_disable_agent. */
export function isHumanHandoffVisualStage(
  stageSlug: string | null | undefined,
  stagesBySlug?: Map<string, LeadStageConfig>,
): boolean {
  if (!stageSlug) return false;
  const cfg = stagesBySlug?.get(stageSlug);
  if (cfg?.is_human_handoff === true) return true;
  return stageSlug === "atendimento_humano";
}

export function handoffStageDisplayName(
  stageSlug: string,
  stagesBySlug?: Map<string, LeadStageConfig>,
): string {
  return stagesBySlug?.get(stageSlug)?.name ?? stageSlug;
}
